import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import type { Trip } from '../types';

interface DeleteTripDialogProps {
  trip: Trip | null;
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting?: boolean;
}

export function DeleteTripDialog({ trip, open, onClose, onConfirm, isDeleting = false }: DeleteTripDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-trip-dialog-title">
      <DialogTitle id="delete-trip-dialog-title">Excluir Trip</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja excluir a trip <strong>{trip?.title}</strong>? Esta acao não pode ser desfeita.
          Todos os pins associados a esta trip também serao removidos.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
          {isDeleting ? 'Excluindo...' : 'Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
